import { Module } from '@nestjs/common';
import { AiHoldingController } from './ai-holding.controller';
import { AiHoldingService } from './ai-holding.service';

// Administración de tokens de IA a nivel holding (consumo por empresa + ajuste de cuotas).
// PrismaModule es @Global; la estrategia 'jwt' se registra en AuthModule (app-wide).
@Module({
  controllers: [AiHoldingController],
  providers: [AiHoldingService],
})
export class AiHoldingModule {}
